import React, { useCallback, useState } from 'react';
import { Form } from 'antd';
import Modal from '@/components/popup/Modal';
import messageInForm from '@/assets/messageForm';
import InputPassword from '@/components/inputPassword/InputPassword';

interface Values {
  title: string;
  description: string;
  modifier: string;
}

interface TModalToChangePasswordProps {
  visible: boolean;
  onOk: (values: Values) => void;
  onCancel: () => void;
  loading?: boolean;
  isPassword?: boolean;
}

const ModalToChangePassword: React.FC<TModalToChangePasswordProps> = ({
  visible,
  onOk,
  onCancel,
  loading,
  isPassword,
}) => {
  const [form] = Form.useForm();
  const password = Form.useWatch('password', form);
  const password2 = Form.useWatch('password2', form);

  const [buttonDisabled, setButtonDisabled] = useState(true);

  const handleOkModal = useCallback(() => {
    form
      .validateFields()
      .then((values) => {
        form.resetFields();
        onOk(values);
      })
      .catch((info) => {
        console.log('Validate Failed:', info);
      });
  }, [form, onOk]);

  const handleCancelModal = useCallback(() => {
    onCancel();
    form.resetFields();
  }, [onCancel, form]);

  return (
    <Modal
      open={visible}
      data-visible={visible}
      width="340px"
      title={`${isPassword ? '비밀번호 변경' : '비밀번호 등록'} `}
      okText="확인"
      cancelText="취소"
      closable={false}
      onCancel={handleCancelModal}
      onOk={handleOkModal}
      loading={loading}
      isButtonDisabled={buttonDisabled}
    >
      <p>새로운 비밀번호를 입력해주세요.</p>
      <Form
        form={form}
        name="formInModal"
        layout="vertical"
        requiredMark={false}
        autoComplete="off"
        data-testid="checkPassword"
      >
        <Form.Item
          name="password"
          rules={[
            {
              pattern: new RegExp(
                /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d@$!%*#?&~+\-=/_|<>\[\](){}'":;,]{8,}$/,
              ),
              message: messageInForm.password2.error2,
            },
            { required: true, message: messageInForm.password2.error },
          ]}
          className="mt-[2.4rem]"
        >
          <InputPassword
            visibleIcon={password && password.length > 0}
            visibilityToggle
            placeholder={messageInForm.password2.placeholder}
          />
        </Form.Item>

        <Form.Item
          name="password2"
          dependencies={['password']}
          validateFirst="parallel"
          rules={[
            { required: true, message: messageInForm.password3.error },
            ({ getFieldValue }) => ({
              validator(_, value) {
                const reg = new RegExp(
                  /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d@$!%*#?&~+\-=/_|<>\[\](){}'":;,]{8,}$/,
                );
                if (!value || (getFieldValue('password') === value && reg.test(value))) {
                  setButtonDisabled(false);
                  return Promise.resolve();
                }
                setButtonDisabled(true);
                return Promise.reject(new Error(messageInForm.password3.error2));
              },
            }),
          ]}
          className="mt-[2.8rem]"
        >
          <InputPassword
            visibleIcon={password2 && password2.length > 0}
            visibilityToggle
            placeholder={messageInForm.password3.placeholder}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ModalToChangePassword;
